import { Theme } from '@mui/material';
import SassColor from 'src/utils/sass_color_utils';
import {
  WsdAlertColorName,
  WsdAlertPaletteColors,
} from 'src/wsd/components/WsdAlert/style/palette/types';

export const wsdAlertToastBgAlpha = 0.85;

export const wsdAlertPalettes: Record<
  WsdAlertColorName,
  (theme: Theme) => WsdAlertPaletteColors
> = {
  info: (theme) => {
    const { info } = theme.palette;
    return {
      bgStandard: {
        default: SassColor.lighten(info.main, 42),
      },
      bdLeft: {
        default: SassColor.darken(info.main, 5),
      },
      bgFilled: {
        default: SassColor.rgba(info.dark, wsdAlertToastBgAlpha),
      },
    };
  },
  success: (theme) => {
    const { success } = theme.palette;
    return {
      bgStandard: {
        default: SassColor.tintOf(success.main, 0.12),
      },
      bdLeft: {
        default: SassColor.tintOf(success.dark, 0.7),
      },
      bgFilled: {
        default: SassColor.rgba(success.dark, wsdAlertToastBgAlpha),
      },
    };
  },
  warning: (theme) => {
    const { warning } = theme.palette;
    return {
      bgStandard: {
        default: SassColor.tintOf(warning.main, 0.12),
      },
      bdLeft: {
        default: SassColor.tintOf(warning.dark, 0.7),
      },
      bgFilled: {
        default: SassColor.rgba(warning.dark, wsdAlertToastBgAlpha),
      },
    };
  },
  error: (theme) => {
    const { error } = theme.palette;
    return {
      bgStandard: {
        default: SassColor.tintOf(error.main, 0.12),
      },
      bdLeft: {
        default: SassColor.tintOf(error.dark, 0.7),
      },
      bgFilled: {
        default: SassColor.rgba(error.dark, wsdAlertToastBgAlpha),
      },
    };
  },
};
